import React from 'react'
import './middle.css'

// Import Icons
import { SiYourtraveldottv } from 'react-icons/si'
import { GiWallet } from 'react-icons/gi'
import { TbMap2 } from 'react-icons/tb'
import { PiBookDuotone } from 'react-icons/pi'

// Card Home Data
const cardHome = [
  {
    id: 1,
    icon: <SiYourtraveldottv className="icon" />,
    title: 'Guidance',
    description: 'Expert insight & travel Knowledge'
  },
  {
    id: 2,
    icon: <GiWallet className="icon"/>,
    title: 'Offers & Benefits',
    description: 'Irresistible rates, offers & benefits'
  },
  {
    id: 3,
    icon: <TbMap2 className="icon"/>,
    title: 'Peace of Mind',
    description: 'Reassurance to book with confidence'
  },
  {
    id: 4,
    icon: <PiBookDuotone className="icon"/>,
    title: 'Guidance',
    description: 'Beside you every step of the way'
  }
]

const Middle = () => {
  return (
    <div className="cards__middle grid">
      {cardHome.map((item) => { 
        const { id, icon, title, description } = item;
        return (
          <article key={id} className="card__middle">
            {icon}
            <div className="card__middle__content">
              <h1>{title}</h1>
              <p>{description}</p>
            </div>
          </article>
        )
      })}
    </div>
  )
}

export default Middle
